// Klaviyo "Viewed Product" + recently-viewed item. Pushed onto the `_learnq` queue, which
// Klaviyo's onsite script drains whether it loads before or after this.
const el = document.querySelector('[data-klaviyo-viewed-product]');
let item = null;
try {
    item = el ? JSON.parse(el.textContent) : null;
} catch (e) {
    item = null;
}

if (item) {
    const _learnq = (window._learnq = window._learnq || []);
    _learnq.push(['track', 'Viewed Product', item]);
    _learnq.push(['trackViewedItem', {
        Title: item.Name,
        ItemId: item.ProductID,
        Categories: item.Categories,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
            Brand: item.Brand,
            Price: item.Price,
            CompareAtPrice: item.CompareAtPrice,
        },
    }]);
}
